<script>

import Modal from "./Modal.vue";
import {axios} from "../mixins";

export default {
  name: "Comments.vue",

  mixins: [axios],

  components: {
    Modal
  },
  
  props: {
  },

  data() {
    return {
      loading: false,
      id: 0,
      title: '',
      subTitle: '',
      comments: [],
      input: '',
      relation: '',
      rowIndex: 0,
      subRowIndex: 0,
      rowType: '',
    }
  },
  
  methods: {
    setData(id, title, subTitle, relation, index, subIndex, rowType) {
      this.comments = [];
      this.id = id;
      this.title = title
      this.subTitle = subTitle
      this.relation = relation;
      this.getComments()
      this.$refs.commentsModal.open()
      this.rowIndex = index
      this.subRowIndex = subIndex
      this.rowType = rowType
    },

    getComments() {
      this.loading = true;

      let route = '/comments?modelID=' + this.id + '&relation=' + this.relation;

      this.get(route).then((response) => {
        this.comments = response.data.comments;
        this.loading = false;

        this.$nextTick(function() {
          if (this.comments.length !== 0) {
            this.$refs['commentScroll'].lastElementChild.scrollIntoView();
          }
        });
      })
    },

    // Post a comment for the currently open comment modal
    postComment() {
      let route = '/comment'

      let data = {
        'model_id': this.id,
        'message': this.input,
        'relation': this.relation,
      }

      this.post(route, {params: data}).then((response) => {
        this.input = null;
        this.comments.push(response.data.newComment);
        // Update the dashboard comments icon to visibly show the comment was successfully posted
        this.broadcastUpdate(true)
        this.$nextTick(function() {
          this.$refs['commentScroll'].lastElementChild.scrollIntoView();
        });
      })
    },

    broadcastUpdate(value) {
      // Update the comment column modifier key, which indicates the row should show the chat bubble
      this.$emit('updateColModifierKey', {
        'rowIndex': this.rowIndex,
        'subRowIndex': this.subRowIndex,
        'rowType': this.rowType,
        'modifierKey': 'hasComments',
        'value': value,
      })
    }
  }
}
</script>

<template>
  <Modal ref="commentsModal" :large="true">
    <div class="w-full bg-primary p-2">
      <div class="pb-1">
        <h1>{{ this.title }}</h1>
        <h2>{{ this.subTitle }}</h2>
      </div>

      <div v-if="this.loading && this.comments.length === 0" class="w-full font-semibold text-xl text-center">
        Loading...
      </div>
      <div v-else-if="this.comments.length === 0" class="italic text-xl text-center">
        No data to display.
      </div>

      <div class="w-full px-2 bg-secondary rounded-lg mb-2 overflow-scroll" style="max-height: 20rem;" ref="commentScroll">
        <template v-for="(row, index) in this.comments">
          <div :class="(this.comments.length - 1) > index ? `border-b border-grey-light` : ``">
            <div class="">
              <span>
                {{ row.name }} &bull; {{ row.posted }}
              </span>
            </div>
            <div class="mt-2">
              {{ row.message }}
            </div>
          </div>
        </template>
      </div>

      <div>
          <textarea placeholder="Post an update"
                    id="commentModalTextArea"
                    v-model="this.input"
                    class="placeholder:italic bg-primary border border-grey-light w-full px-3 rounded-md leading-tight focus:outline-none"
          />
      </div>
    </div>
    <template #toggle="{open}"></template>
    <template #footer="{cancel}">
      <button type="button"
              class="button button-wide text-white bg-green hover:bg-green-dark focus:bg-green-darker mt-2 font-bold mx-2"
              @click="postComment()">
        Post
      </button>
      <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button type="button"
                  class="button button-wide bg-secondary hover:bg-grey-lightest focus:bg-grey-lighter mt-2 font-bold mr-2"
                  v-on:click="cancel">
            Close
          </button>
        </span>
    </template>
  </Modal>
</template>